import React from 'react';
import { auth, provider } from './firebase';

function LoginPage() {
  const signInWithGoogle = async () => {
    try {
      await auth.signInWithPopup(provider);
    } catch (error) {
      console.error('Error signing in:', error);
    }
  };

  return (
    <div className="LoginPage" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '70vh', flexDirection: 'column'}}>
        <img src="https://i.imgur.com/s7eNk72.png" alt="it's wabbit!" style={{ borderRadius: '50%', width: '150px', height: '150px' }} />
        <h1>Wabbit is excited to meet you!</h1>
        <button className="google-signin-btn" onClick={signInWithGoogle} />
        {/* <p style={{marginTop: '40px'}}>Learn more about Wabbit here</p> */}
    </div>
  );
}

export default LoginPage;